require('./modifyDebitLimitsStep2.scss');

// @ vendor
const PropTypes = require('prop-types');
const React = require('react');
// @ constants
const { CARD_MODIFY_DEBIT_LIMITS_ID } = require('constants/operationTypes');
const { FIRST_STEP } = require('constants/index');
//@commons
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
// @ components
const ModifyDebitLimitsInformativeSection = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsInformativeSection/modifyDebitLimitsInformativeSection');

class ModifyDebitLimitsStep2 extends React.Component {
    render() {
        const { immCard, immCardModifyDebitLimits } = this.props;
        const immStepOne = immCardModifyDebitLimits.getIn(['steps', FIRST_STEP]);
        const params = {
            currency: immStepOne.get('currency'),
            ammount: immStepOne.get('limit'),
            pan: immCard.get('number'),
            optional1: immCardModifyDebitLimits.get('operationType')
        };

        return (
            <article className="modify-debit-limits-step-two">
                <ModifyDebitLimitsInformativeSection
                    immCard={immCard}
                    immCardModifyDebitLimits={immCardModifyDebitLimits}
                    titleKey="modifyDebitLimitsInformativeSection-stepTwoTitle"
                />
                <section className="modify-debit-limits-step-two__content">
                    <SignaturePattern
                        operationType={CARD_MODIFY_DEBIT_LIMITS_ID}
                        operationParams={params}
                    />
                </section>
            </article>
        );
    }
}

ModifyDebitLimitsStep2.propTypes = {
    immCardModifyDebitLimits: PropTypes.object,
    immCard: PropTypes.object
};

module.exports = ModifyDebitLimitsStep2;
